module.exports = __webpack_public_path__ + "static/media/shape_2.615241f8.png";